import { useEffect, useState } from "react";
import FinishedQuiz from "../FinishedQuiz";
import { toast } from "react-toastify";

import QuestionData from "./ArrangeJson.json";

const shuffleArray = (array) => {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

const arraysEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);

// --- Component ---
const QuizContainer = ({
  setIsActive,
  setStart,
  compliments,
  setIsFinished,
  isFinished,
  setSeconds,
  seconds,
  isStarted,
}) => {
  const [selectedArrange, setSelectedArrange] = useState([]);
  const [score, setScore] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [suffledQuestions, setSuffledQuestions] = useState([]);
  const [tries, setTries] = useState(0);
  const totalQuestion = suffledQuestions?.length;
  const currentQuestion = suffledQuestions && suffledQuestions[currentIndex];

  const [progress, setProgress] = useState(
    ((currentIndex + 1) / totalQuestion) * 100
  );

  // Shuffle sub-questions on question change
  useEffect(() => {
    const suffle = QuestionData?.slice(0, 10);
    setSuffledQuestions(shuffleArray(suffle));
  }, []);

  const handleSubmit = () => {
    const userAnswer = selectedArrange.map((item) => item?.value);
    const correctAnswer = currentQuestion?.correctOrder.map(
      (item) => item?.value
    );

    const nextProgress = ((currentIndex + 2) / totalQuestion) * 100;
    const isCorrect = arraysEqual(userAnswer, correctAnswer);

    if (isCorrect) {
      setScore((prev) =>
        tries === 1
          ? prev + 5
          : tries < 1
          ? prev + 10
          : tries === 2
          ? prev + 1
          : prev + 0
      );
      setCurrentIndex((prev) => prev + 1);
      setSelectedArrange([]);
      setProgress(nextProgress);
      setTries(0);

      if (currentIndex + 1 === totalQuestion) {
        setSeconds(0);
        setIsFinished(true);
      }
    }
  };
  useEffect(() => {
    const userAnswer = selectedArrange.map((item) => item.value);
    const correctAnswer = currentQuestion?.correctOrder.map(
      (item) => item.value
    );
    if (selectedArrange?.length === currentQuestion?.correctOrder?.length) {
      const isCorrect = arraysEqual(userAnswer, correctAnswer);
      if (isCorrect) {
        toast(compliments[Math.floor(Math.random() * 10)], {
          className: "toast-correct d-flex justify-content-center",
          hideProgressBar: true,
          closeButton: false,
          onClose: () => handleSubmit(),
        });
      } else {
        setTries(tries + 1);
        toast("Try again", {
          className: "toast-wrong d-flex justify-content-center",
          hideProgressBar: true,
          closeButton: false,
        });
      }
    }
  }, [selectedArrange]);

  const handleReset = () => {
    setStart(false);
    setSeconds(160);
    setIsFinished(false);
    setCurrentIndex(0);
    setScore(0);
    setSelectedArrange([]);
  };

  const handleRemove = (item) => {
    setSelectedArrange((prev) => prev.filter((i) => i.id !== item.id));
  };

  if (currentIndex >= totalQuestion || isFinished) {
    return (
      <FinishedQuiz
        handleReset={handleReset}
        score={score}
        type={"arrange"}
        questionsCount={totalQuestion}
      />
    );
  }

  // UI Component return
  return (
    <div
      className="w-100 py-4 rounded-2"
      style={{ height: "100%", overflow: "auto" }}
    >
      <div className="d-flex px-4 justify-content-between">
        <small>
          Question {currentIndex + 1} of {totalQuestion}
        </small>
        <p>Score: {score}</p>
      </div>

      {/* Progress */}
      <div className="d-flex px-4 flex-column align-items-center gap-0">
        <div
          className="w-100 mb-4 rounded-3"
          style={{ backgroundColor: "rgba(0,0,0,0.1)" }}
        >
          <div
            className="rounded-3"
            style={{
              width: `${progress}%`,
              transition: "all 1s",
              padding: "5px",
              backgroundColor: "blue",
            }}
          />
        </div>

        <div className="d-flex align-items-center w-100 my-1 gap-3">
          <p className="fs-4  p-0 m-0">⏰</p>
          {isStarted && !isFinished && (
            <h4 className="p-0 m-0 rounded-3" style={{ color: "blue" }}>
              {seconds}s
            </h4>
          )}
        </div>
      </div>

      {/* Quiz Body */}
      <div
        className="px-4 d-flex flex-column justify-content-between align-items-center"
        style={{ height: "75%" }}
      >
        <h6 className="text-left w-100">
          {currentIndex + 1}. {currentQuestion?.title}
        </h6>

        <div className="d-flex pt-5 gap-2">
          {selectedArrange?.length === 0
            ? currentQuestion?.correctOrder.map((_, index) => (
                <div key={index} className="mt-4">
                  ......
                </div>
              ))
            : selectedArrange?.map((item, index) => (
                <h3
                  key={index}
                  className="text-white px-3 rounded-3 p-2"
                  onClick={() => handleRemove(item)}
                  style={{
                    backgroundColor:
                      item?.id === currentQuestion?.correctOrder[index]?.id
                        ? "rgb(87, 238, 28)"
                        : "rgb(235, 0, 0)",
                    cursor: "pointer",
                  }}
                >
                  {item?.value}
                </h3>
              ))}
        </div>

        {/* Answer Buttons */}
        <div className="px-3 gap-3 d-flex flex-wrap w-100 mt-3">
          {currentQuestion?.randomOrder?.map((item) => (
            <button
              key={item.id}
              disabled={selectedArrange.some((sel) => sel.id === item.id)}
              className="rounded-2 px-3 text-black fs-5"
              style={{
                border: "2px solid rgba(92, 89, 89, 0.55)",
              }}
              onClick={() => {
                setSelectedArrange((prev) => [...prev, item]);
                setIsActive(true);
              }}
            >
              {item.value}
            </button>
          ))}
        </div>

        <div className="d-flex w-100 justify-content-end mt-2">
          <button
            style={{ border: "none" }}
            disabled={currentIndex + 1 > totalQuestion}
            className="px-3 rounded-2 bg-info text-white p-2"
            onClick={() => setSelectedArrange([])}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuizContainer;
